import React, { MouseEventHandler } from 'react';
import cx from 'classnames';
import { ForgeIcon, ForgeListItem, ForgeTooltip } from '@tylertech/forge-react';
import { fetchTranslation } from 'common/locale';
import { Tab } from 'common/explore_grid/types';

const t = (k: string) => fetchTranslation(k, 'shared.explore_grid.grid_datasource');

const iconFor = (tab: Tab): JSX.Element => {
  const label = t(tab);
  switch (tab) {
    case Tab.ColumnManager:
      return createIcon('view_column', label);
    case Tab.Filter:
      return createIcon('filter', label);
    case Tab.Aggregate:
      return createIcon('group', label);
    case Tab.Join:
      return createIcon('set_none', label);
    case Tab.Code:
      return createIcon('code', label);
    case Tab.Parameters:
      return createIcon('variable', label);
    case Tab.Search:
      return createIcon('search', label);
    default:
      return createIcon('head_question_outline', label);
  }
};

const createIcon = (iconName: string, label: string): JSX.Element => {
  return <ForgeIcon className='grid-datasource-tab-icon-forge' name={iconName} aria-label={label} />;
};

export interface Props {
  className?: string;
  onClick: (toTab: Tab) => MouseEventHandler<HTMLAnchorElement>;
  selectedClass: (toTab: Tab) => string;
  toTab: Tab;
  targetWindow?: Window;
}

export default class TabLink extends React.Component<Props> {
  render() {
    const { className, onClick, selectedClass, toTab } = this.props;
    const name = t(toTab);
    const classNames = cx('grid-datasource-tab-item tab-link', className, selectedClass(toTab));

    return (
      <>
        <ForgeListItem
          className={classNames}
          onClick={onClick(toTab)}
          role="tab"
          selected={selectedClass(toTab) === 'current'}
          aria-controls="grid-datasource-tabpanel"
          data-testid={`ec-tab-link-${toTab}`}
        >
          {iconFor(toTab)}
        </ForgeListItem>
        <ForgeTooltip>{name}</ForgeTooltip>
      </>
    );
  }
}
